export interface WizardPane {
  label: string;
  valid: boolean;
  touched: boolean;
}

export interface WizardOptions {
  panePosition: string;
}

export interface WizardDefault {
  introduction: WizardPane;
  properties: WizardPane;
  finishAndNextStep: WizardPane;
  options: WizardOptions;
}

export interface SelectOption {
  label: string;
  value: any;
}

export enum DisplayType {
  grid,
  slideInModal,
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-form/types.ts